<template>
  <v-sheet rounded>
    <v-row class="py-8">
      <v-col cols="12" md="6" class="d-flex align-center">
        <div class="px-8">
          <div class="body-2 font-weight-bold">
            Potenciální dosah:
            {{ reach > 0 ? reach.toLocaleString() + " lidí" : " -" }}
          </div>
          <div v-text="description" />
        </div>
      </v-col>
      <v-col
        cols="12"
        md="6"
        class="d-flex align-center justify-center pt-8 pt-md-0"
      >
        <ReachDial class="d-block mx-auto" :value="dialValue" />
      </v-col>
    </v-row>
  </v-sheet>
</template>

<script>
import { get } from "vuex-pathify"
import ReachDial from "./ReachDial.vue"

export default {
  name: "ReachDialBox",
  components: {
    ReachDial,
  },
  props: {
    storeNamespace: {
      type: String,
      required: true,
    },
  },
  beforeCreate() {
    const storeNamespace = this.$options.propsData.storeNamespace

    Object.assign(this.$options.computed, {
      ...get(`${storeNamespace}/model@audience`, ["targeting"]),
    })
  },
  created() {
    this.loadEstimatedReach(this.targeting)
  },
  computed: {
    reach() {
      return this.$store.state.targeting.estimatedReach
    },
    dialValue() {
      return this.reach / 6000000
    },
    description() {
      if (this.reach === 0 && this.targeting.geoLocations.length == 0) {
        return "Pro výpočet dosahu je potřeba zvolit alespoň jednu lokalitu"
      } else if (this.reach === 0) {
        return "Dosah nelze spočítat."
      } else if (this.reach === null) {
        return "Počítám..."
      } else if (this.reach > 3000000) {
        return "Váš výběr publika je poměrně široký"
      } else {
        return "Váš výběr publika je poměrně specifický"
      }
    },
  },
  methods: {
    loadEstimatedReach(targeting) {
      this.$store.dispatch("targeting/getEstimatedReach", targeting)
    },
  },
  watch: {
    targeting: {
      handler: function(newValue) {
        this.loadEstimatedReach(newValue)
      },
      deep: true,
    },
  },
}
</script>
